/** Responsive type scale for marketing masthead titles (matches homepage Hero h1). */
export const MASTHEAD_TITLE_SCALE_CLASS = "text-display-md md:text-display-lg lg:text-display-2xl";

/** Full masthead title styling (display font, extrabold, primary text). */
export const MASTHEAD_TITLE_CLASS = `font-display font-extrabold text-balance text-text-primary ${MASTHEAD_TITLE_SCALE_CLASS}`;

/** Width + horizontal padding aligned with `.page-shell` (16px mobile, 32px md+). */
export const PAGE_SHELL_CLASS = "page-shell";

/** Page masthead title when it sits outside an existing shell wrapper. */
export const PAGE_MASTHEAD_TITLE_CLASS = `${PAGE_SHELL_CLASS} ${MASTHEAD_TITLE_CLASS}`;

/** Subtle pure black/white outline for images — avoids tinted neutrals that read as dirt on edges. */
export const IMAGE_OUTLINE_CLASS =
	"outline outline-black/10 dark:outline-white/10 dark-mode:outline-white/10";
